<template>
    <AppHead title="Passwort vergessen" />
    <div class="lg:px-64">
        <PageTitle>Passwort vergessen</PageTitle>
        <div class="mb-4 text-sm text-gray-600">
            Sie haben Ihr Passwort vergessen? Kein Problem. Teilen Sie uns einfach Ihre E-Mail-Adresse mit und wir senden Ihnen per E-Mail einen Link zum Zurücksetzen des Passworts. Dann können Sie ein neues Passwort vergeben.
        </div>
        <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
            {{ status }}
        </div>
        <ValidationErrors class="mb-4" />
        <form @submit.prevent="submit">
            <div>
                <FormLabel for="email" value="E-Mail-Adresse" />
                <FormInput id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autofocus autocomplete="username" />
            </div>
            <div class="flex items-center justify-end mt-4">
                <FormButton :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                    E-Mail zum Zurücksetzen des Passworts versenden
                </FormButton>
            </div>
        </form>
    </div>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3';
import AppHead from '@/Shared/Head'
import PageTitle from '@/Shared/Page/Title'
import FormButton from '@/Shared/Form/Button.vue';
import FormInput from '@/Shared/Form/Input.vue';
import FormLabel from '@/Shared/Form/Label.vue';
import ValidationErrors from '@/Shared/Form/ValidationErrors.vue';

defineProps({
    status: String,
});
const form = useForm({
    email: '',
});
const submit = () => {
    form.post(route('manager.password.email'));
};
</script>
